export default __webpack_public_path__ + "static/media/PLANTA_DE_MANI.f8d9bc4d.mtl";